import { useState } from 'react';
import { ASK_AICA_GREETINGS } from '../../../../../../../../store/dashboard/askAica/constants';
import styles from './AskAicaGreeting.module.scss';

// The empty-chat greeting, shared by the desktop modal and the mobile
// full-screen surface — same purple→pink gradient, Gilroy Medium on both.
// Entrance: a soft-edged wipe reveals the words left to right while the line
// sharpens from a blur. Single element on purpose: per-word spans with filters
// break background-clip: text in Chrome (the gradient stops painting).
function AskAicaGreeting() {
    const [greeting] = useState(() => ASK_AICA_GREETINGS[Math.floor(Math.random() * ASK_AICA_GREETINGS.length)]);

    return (
        <div className={styles.Greeting} data-testid="ask-aica-greeting">
            {greeting}
        </div>
    );
}

export default AskAicaGreeting;
